import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {provideRouter, withComponentInputBinding, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {provideHttpClient, withFetch} from '@angular/common/http'
import {WINDOW, windowProvider} from './application/window.provider'
import {ConfigService} from './services/config.service'
import {VideoDemoConfiguration} from './application/configuration'

export const appConfig: ApplicationConfig = {
  providers: [
    {provide: WINDOW, useFactory: windowProvider},
    provideAppInitializer(() => {
      const initializerFn = ((s: ConfigService) => () => s.setConfiguration(VideoDemoConfiguration))(inject(ConfigService))
      return initializerFn()
    }),
    provideRouter(routes,
      withComponentInputBinding(),
      withHashLocation()
    ),
    provideHttpClient(
      withFetch()
    )
  ]
}
